/**
 * Extract last options from the string
 * @param {String} input
 * @returns {Map<"options" | "rest", any>}
 */
const extractLastOptions = (input) => {
  const result = input;

  /** @type {Map<"options" | "rest", any>} */
  const map = new Map([
    ["options", null],
    ["rest", input],
  ]);

  if (input.includes("<") && input.endsWith(">")) {
    const matches = input.matchAll(/</g);
    const match = Array.from(matches).pop();

    if (match?.length) {
      const options = result.slice(match.index);
      const rest = result.slice(0, match.index);

      map.set("options", options);
      map.set("rest", rest);

      return map;
    } else {
      return map;
    }
  }

  return map;
};

export default extractLastOptions;
